module.exports = __webpack_public_path__ + "img/pastefy.e1cdf365.png";